module.exports = __webpack_public_path__ + "img/max-cloud-add.9076d716.svg";